module.exports = __webpack_public_path__ + "static/media/dst-off.73865615.png";